import React from 'react';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../api';
import { ContainerLoader } from '../../components/loader';
import { Settings, NotificationTemplate } from '../../core';
import AppLayout from '../../core/layouts/AppLayout';
import '../../styles/listing.scss';
import '../../styles/settings.scss';

import {
  ContentSettingsMenu,
  ContentSettingsTabNames,
} from './components/content-settings-menu';
import { TemplateTabbedContent } from './components/template-tabbed-content';
import TemplateSettingsItems from './components/template-settings-items';
import District from './components/district';
import Governorate from './components/governorate';
import Tag from './components/tags';

export const ContentSettingsPage: React.FunctionComponent = () => {
  const [tabName, setTabName] = React.useState<ContentSettingsTabNames>(
    ContentSettingsTabNames.Template
  );

  const [selectedKey, setSelectedKey] = React.useState<string>();

  const handleTabChange = (tabNameValue: ContentSettingsTabNames) => {
    setTabName(tabNameValue);
  };

  const {
    data: template,
    reload: loadTemplate,
    loaded: loadedTemplate,
    loading: loadingTemplate,
  } = useDataLoader<NotificationTemplate>(() =>
    selectedKey ? api.settings.getTemplateContent(selectedKey || '') : ''
  );

  const { data: settings, loaded, loading, reload } = useDataLoader<Settings>(
    () => api.settings.getSettings()
  );

  React.useEffect(() => {
    if (selectedKey) {
      loadTemplate();
    }
  }, [selectedKey]);

  return (
    <AppLayout>
      <div className="list-head border-bottom py-4 px-3">
        <h2 className="m-0 font-weight-semibold">Content Settings</h2>
      </div>
      {(!loaded || loading) && <ContainerLoader></ContainerLoader>}
      {settings && (
        <div className="row no-gutters ch-100">
          <ContentSettingsMenu
            tabChangeHandler={handleTabChange}
            tabName={tabName}
            data={settings}
          />

          {tabName === ContentSettingsTabNames.Template && (
            <TemplateSettingsItems
              data={{
                currency: settings.currency,
                timeZone: settings.timeZone?.timeZone!,
                franchiseName: settings.franchiseName,
                removeVisibilityGroupChildrenOnDelete:
                  settings.removeVisibilityGroupChildrenOnDelete,
                logoUrl: settings.logoUrl,
                alghanimLogoUrl: settings.alghanimLogoUrl,
              }}
              reload={reload}
              onSelectTemplate={(key: string) => setSelectedKey(key)}
            />
          )}
          {tabName === ContentSettingsTabNames.District && <District />}
          {tabName === ContentSettingsTabNames.Governorate && <Governorate />}
          {tabName === ContentSettingsTabNames.Tag && <Tag />}
          {template &&
            !loadingTemplate &&
            tabName === ContentSettingsTabNames.Template && (
              <TemplateTabbedContent
                templateDetails={template}
                realod={() => {
                  loadTemplate();
                }}
              />
            )}
        </div>
      )}
    </AppLayout>
  );
};

export default ContentSettingsPage;
